export enum PopupSize {
    NORMAL = "normal",
    FULL_SCREEN = "fullScreen",
}